<script lang="ts" setup>
import type { Editor } from '@tiptap/vue-3'
import type { StyleValue } from 'vue'
import { computed } from 'vue'
import { DropdownMenuItem } from '@/foundation/dropdown-menu'
import { Toggle } from '@/foundation/toggle'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/foundation/tooltip'
import ActionDropdownButton from '@/notebook/components/ActionDropdownButton.vue'
import { Icon, type icons } from '@/notebook/components/icons'
import type { ButtonViewReturnComponentProps } from '@/notebook/type'
import { getShortcutKey } from '@/notebook/utils/plateform'

export type Item = {
  title: string
  icon?: keyof typeof icons
  isActive: NonNullable<ButtonViewReturnComponentProps['isActive']>
  action?: ButtonViewReturnComponentProps['action']
  style?: StyleValue
  shortcutKeys?: string[]
  disabled?: boolean
  divider?: boolean
  default?: boolean
}
type Props = {
  editor: Editor
  disabled?: boolean
  color?: string
  maxHeight?: string | number
  icon?: any
  tooltip?: string
  items?: Item[]
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  color: undefined,
  maxHeight: undefined,
  icon: undefined,
  tooltip: '',
  items: () => [],
})

const active = computed(() => {
  const find: any = props.items.find((k: any) => k.isActive())

  if (find && !find.default) {
    return {
      ...find,
      icon: find.icon ? find.icon : props.icon,
    }
  }
  const item: Item = {
    title: props.tooltip,
    icon: props.icon,
    isActive: () => false,
  }

  return item
})
</script>

<template>
  <ActionDropdownButton :icon="icon" :tooltip="tooltip" :disabled="disabled" class="min-w-4 w-full flex flex-row gap-1">
    <TooltipProvider>
      <Tooltip v-for="(item, index) in props.items" :key="index">
        <TooltipTrigger as-child>
          <DropdownMenuItem class="p-0" @click="item.action">
            <Toggle size="sm" class="w-7 h-7 p-1" :pressed="active.title === item.title">
              <Icon v-if="item.icon" :name="item.icon" />
            </Toggle>
          </DropdownMenuItem>
        </TooltipTrigger>
        <TooltipContent class="flex flex-col items-center">
          <span>{{ item.title }}</span>
          <span>
            {{ item.shortcutKeys?.map((item) => getShortcutKey(item)).join(' ') }}
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </ActionDropdownButton>
</template>
